var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57342 1.39058C6.02244 0.00860953 7.97756 0.00860977 8.42658 1.39058L8.90837 2.87336C9.10918 3.49139 9.68511 3.90983 10.335 3.90983H11.894C13.3471 3.90983 13.9513 5.76925 12.7757 6.62335L11.5144 7.53976C10.9887 7.92173 10.7687 8.59878 10.9695 9.21681L11.4513 10.6996C11.9003 12.0816 10.3186 13.2307 9.14301 12.3766L7.88168 11.4602C7.35595 11.0783 6.64405 11.0783 6.11832 11.4602L4.85699 12.3766C3.68142 13.2307 2.0997 12.0816 2.54873 10.6996L3.03052 9.21681C3.23133 8.59878 3.01134 7.92173 2.48561 7.53976L1.22428 6.62335C0.0487113 5.76925 0.652875 3.90983 2.10596 3.90983H3.66505C4.31489 3.90983 4.89082 3.49139 5.09163 2.87336L5.57342 1.39058Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightStar);
export default __webpack_public_path__ + "static/media/lightStar.6931e30abe59455a19d87b627ffa0369.svg";
export { ForwardRef as ReactComponent };